import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// Self-hosted Poppins font (faster than Google Fonts CDN)
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/500.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
